export const zConf = {
    V1: 'https://zoomers-revealed.s3.amazonaws.com/images/variant1/',
    V2: 'https://zoomers-revealed.s3.amazonaws.com/images/variant2/',
    V3: 'https://zoomers-revealed.s3.amazonaws.com/images/variant3/',
    V4: 'https://zoomers-revealed.s3.amazonaws.com/images/variant4/'
}